/* ============================================================
   SOLVEY · Volume / stapelkorting tegel-selector
   ------------------------------------------------------------
   Klik op een tegel -> (1) zet de PDP quantity-input op het gekozen
   aantal, (2) zet de getoonde stuksprijs op de "Eenmalige aankoop"-
   kaart gelijk aan de gekozen tegel.

   De TEGELS tonen de stuksprijs van de gekozen AANKOOPOPTIE:
     - eenmalig -> volume-stuksprijs (data-unit-money, met save + badge)
     - abonnement -> de abo-stuksprijs (gelezen van de abo-kaart; platte
       15% zonder volumekorting, dus voor elk aantal gelijk). In abo-modus
       worden volume-badge + save-pill verborgen (CSS .is-subscription).
   Zo weerspiegelt de weergave precies wat de cart afrekent.

   ⚠️ Alles READ-ONLY t.o.v. Firmhouse: we lezen [name=selling_plan] en de
   abo-kaartprijs, en passen alleen quantity + tegel-display aan. Raakt NOOIT
   de radio's/het formulier -> kan afrekenen niet breken. De echte korting
   komt van de Shopify automatische hoeveelheidskorting (eenmalig-regel).

   - Idempotent (data-vtBound) tegen dubbel-binden bij app-re-render.
   - Scoped per .product zodat product-forms los staan.
   ============================================================ */
(function () {
  'use strict';

  function getScope(root) {
    return root.closest('.product') || document;
  }

  function setQuantity(scope, n) {
    var inputs = scope.querySelectorAll('[data-quantity-input], input[name="quantity"]');
    Array.prototype.forEach.call(inputs, function (inp) {
      if (String(inp.value) === String(n)) return;
      inp.value = n;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Read-only: zit de klant op een abonnement? (selling_plan gevuld = abo)
  function isSubscription(scope) {
    var i = scope.querySelector('[name="selling_plan"]');
    return !!(i && i.value && i.value.trim() !== '');
  }

  // De per-stuk abo-prijs zoals Firmhouse 'm toont op de abo-kaart.
  function subUnitMoney(scope) {
    var el = scope.querySelector('.selling_plan_app_container li.subscription-card .total-price');
    return el ? el.textContent.trim() : '';
  }

  // Display-only: getoonde stuksprijs op de "Eenmalige aankoop"-kaart
  // gelijktrekken met de gekozen tegel (altijd de eenmalig-prijs).
  function applyOneTimePrice(scope, money) {
    if (!money) return;
    var el = scope.querySelector('.selling_plan_app_container li.one-time-purchase .total-price');
    if (el && el.textContent.trim() !== money) {
      el.textContent = money;
    }
  }

  // Tegel-stuksprijzen tonen de prijs van de gekozen aankoopoptie.
  function applyTilePrices(root) {
    var scope = getScope(root);
    var sub = isSubscription(scope);
    root.classList.toggle('is-subscription', sub);
    var subMoney = sub ? subUnitMoney(scope) : '';
    var tiles = root.querySelectorAll('[data-vtier]');
    Array.prototype.forEach.call(tiles, function (t) {
      var span = t.querySelector('.solvey-vtiers__unit .wg-notranslate');
      if (!span) return;
      var money = (sub && subMoney) ? subMoney : t.getAttribute('data-unit-money');
      if (money && span.textContent.trim() !== money) span.textContent = money;
    });
  }

  function select(root, tile, syncQty) {
    var scope = getScope(root);
    var tiles = root.querySelectorAll('[data-vtier]');
    Array.prototype.forEach.call(tiles, function (t) {
      var on = t === tile;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var money = tile.getAttribute('data-unit-money');
    root._vtMoney = money; // onthouden voor re-apply na Firmhouse re-render
    applyOneTimePrice(scope, money);
    applyTilePrices(root);
    if (syncQty) {
      var n = parseInt(tile.getAttribute('data-qty'), 10) || 1;
      setQuantity(scope, n);
    }
  }

  function wire(root) {
    if (root.dataset.vtBound) return;
    root.dataset.vtBound = '1';
    var scope = getScope(root);

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-vtier]');
      if (!tile || !root.contains(tile)) return;
      select(root, tile, true);
    });

    // Begin-staat: gemarkeerde tegel (n=1) zonder quantity te forceren.
    var current = root.querySelector('[data-vtier].is-selected') || root.querySelector('[data-vtier]');
    if (current) select(root, current, false);
    applyTilePrices(root);

    function refresh() {
      applyOneTimePrice(scope, root._vtMoney);
      applyTilePrices(root);
    }

    // Firmhouse re-rendert/wisselt aankoopoptie -> herstel prijzen.
    var fh = scope.querySelector('.selling_plan_app_container');
    if (fh && 'MutationObserver' in window) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(refresh, 60);
      }).observe(fh, { childList: true, subtree: true });
    }
    // Vangnet: klik in de Firmhouse-kaart (aankoopoptie wisselen) -> her-evalueer.
    scope.addEventListener('click', function (e) {
      if (!e.target.closest('.selling_plan_app_container')) return;
      setTimeout(refresh, 80);
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-solvey-vtiers]');
    Array.prototype.forEach.call(roots, wire);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  // Vangnet voor late re-render door product-apps.
  setTimeout(init, 800);
})();
